import axiosInstance from "../../api/axios";

const ProgressService = {
  getCourseProgress: async (courseId) => {
    try {
      const response = await axiosInstance.get(`/courses/${courseId}/progress`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch course progress');
      }
    } catch (error) {
      throw error;
    }
  },

  getChapterProgress: async (chapterId) => {
    try {
      const response = await axiosInstance.get(`/chapters/${chapterId}/progress`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch chapter progress');
      }
    } catch (error) {
      throw error;
    }
  },

  markLessonAsCompleted: async (lessonId) => {
    try {
      const response = await axiosInstance.post(`/lessons/${lessonId}/complete`);
      if (response.data.success) {
        return response.data; // Return the full response object
      } else {
        throw new Error('Failed to mark lesson as completed');
      }
    } catch (error) {
      throw error;
    }
  },

  markExerciseAsCompleted: async (exerciseId) => {
    try {
      const response = await axiosInstance.post(`/exercices/${exerciseId}/complete`);
      if (response.data.success) {
        return response.data; // Return the full response object
      } else {
        throw new Error('Failed to mark exercise as completed');
      }
    } catch (error) {
      throw error;
    }
  },
};

export default ProgressService;